import React from "react";
import PropTypes from "prop-types";

import { RoundCheckbox } from "../..";
import "./ScoreboardPositionPicker.scss";

const positions = ["Left", "Center", "Right"];

const ScoreboardPositionPicker = ({ onSelect, selected })=> {
  return (
    <div className="scoreboard-position-picker">
      <span className="scoreboard-position-picker__title">Position:</span>
      {positions.map(position => 
        <div className="scoreboard-position-picker__checkbox-wrapper">
          <RoundCheckbox 
            isSelected={selected === position} 
            onClick={()=> onSelect(position)}
          />
          <span className="scoreboard-position-picker__checkbox-wrapper__text">{position}</span>
        </div>
      )}
    </div>
  );
};

ScoreboardPositionPicker.propTypes = {
  onSelect: PropTypes.func,
  selected: PropTypes.string    
};

ScoreboardPositionPicker.defaultProps = {
  onSelect: ()=> {},
  selected: ""
}

export default ScoreboardPositionPicker;